<script>
import { cn } from "$lib/utils";

let className = "";
export { className as class };
const _class = cn("size-4", "shrink-0", className);
</script>

<svg
  class={_class}
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
  aria-label="Triangle Alert icon"
  {...$$restProps}
  ><path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3"></path><path d="M12 9v4"
  ></path><path d="M12 17h.01"></path></svg
>
